const React = require("react");
const T = React.PropTypes;

require("./MajorMessage.less");

const MajorMessage = React.createClass({
    propTypes: {
        BoxStyle: T.object
    },
    getDefaultProps() {
        return {
            BoxStyle: {}
        };
    },
    render() {
        return (<article className="cs-MajorMessage">
            <section style={this.props.BoxStyle}>{this.props.children}</section>
        </article>);
    }
});

module.exports = MajorMessage;


// WEBPACK FOOTER //
// ./src/components/MajorMessage/MajorMessage.jsx